import { GET_MEAL_SELLOUTS_V3_RESPONSE } from 'lib/constants/v3Actions';

const initialState = {};
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MEAL_SELLOUTS_V3_RESPONSE: {
      return {
        ...state,
        [action.params.menuSlug]: action.response.mealSellouts,
      };
    }
    default:
      return state;
  }
};
